import type { RootState } from '../../App/Store';

export const getNotifications = (state: RootState) => state.notifications;
